import { MENU_ICON_DOT_RADIUS, MENU_ICON_DOTS } from './constants';

export const BottomNavMenuIcon = () => (
  <svg viewBox="-6 -6 36 36" fill="currentColor" aria-hidden>
    {MENU_ICON_DOTS.flatMap((cy) =>
      MENU_ICON_DOTS.map((cx) => (
        <circle key={`${cx}-${cy}`} cx={cx} cy={cy} r={MENU_ICON_DOT_RADIUS} />
      )),
    )}
  </svg>
);
